import React from "react";
import { Counter } from "./components/counter";

export function ControlePosicoes({ formState, setFormState }) {
  function decrementPosicoes() {
    setFormState((prev) => ({
      posicoesQuantity:
        prev.posicoesQuantity > 1
          ? prev.posicoesQuantity - 1
          : prev.posicoesQuantity,
    }));
  }

  function incrementPosicoes() {
    setFormState((prev) => ({ posicoesQuantity: prev.posicoesQuantity + 1 }));
  }

  return (
    <Counter
      onDecrementClick={() => decrementPosicoes()}
      onIncrementClick={() => incrementPosicoes()}
      value={formState.posicoesQuantity}
      min={1}
      data-testid="input-posicoes"
    />
  );
}
